export default "__VITE_ASSET__893b8cd1__"